
import { defineComponent, ref, reactive, computed, onUnmounted} from "vue";

interface userModel {
    userName:string;
    userAge:number
}
export default defineComponent({

    //Options API 和 Composition API
    //
    // Options API 约定：
    //
    // 我们需要在 props 里面设置接收参数
    //
    // 我们需要在 data 里面设置变量
    //
    // 我们需要在 computed 里面设置计算属性
    //
    // 我们需要在 watch 里面设置监听属性
    //
    // 我们需要在 methods 里面设置事件方法
    //
    // 你会发现 Options APi 都约定了我们该在哪个位置做什么事，这反倒在一定程度上也强制我们进行了代码分割。
    //
    // 现在用 Composition API，不再这么约定了，于是乎，代码组织非常灵活，我们的控制代码写在 setup 里面即可。
    //
    // setup函数提供了两个参数 props和context,重要的是在setup函数里没有了this,在 vue3.0 中，访问他们变成以下形式： this.xxx=》context.xxx
    //
    // 我们没有了 this 上下文，没有了 Options API 的强制代码分离。Composition API 给了我们更加广阔的天地，那么我们更加需要慎重自约起来。
    //
    // 对于复杂的逻辑代码，我们要更加重视起 Composition API 的初心，不要吝啬使用 Composition API 来分离代码，用来切割成各种模块导出

    data(){
        return{
            title:'titletitletitle',
            index:0
        }
    },

    methods:{

    },
    created(){
        console.log('myComment-----creat',this.title)
    },
    setup() {
        function onClick (event: Event) {
            console.log('onClick',event)
        }
        function getBtn(){
            const  titlt = "getBtn";

            return (
                <div>
                    <el-button onClick = {onClick}>{titlt}</el-button>
                </div>
            )
        }
        function getDiv(){
            const  titlt = "getDivgetDiv";
            return (
                <div>
                    {titlt}
                </div>
            )
        }
        function changeColor(event:any) {
            console.log('event',event)
            event.srcElement.style.backgroundColor = 'black'
            event.srcElement.style.color = 'white'
        }
        function setDiv() {
            return (
                <div style="width:200px;height:200px;background:red" onClick={changeColor}>
                    点击我改变颜色
                </div>
            )
        }
        return () => (
            <div class="pd-nav">
                <div class="mg10" onClick = {onClick} >
                    这是tsx 语法,使用tsx 开发vue
                    {getDiv()}
                    {getBtn()}
                    {setDiv()}

                </div>
            </div>
        )
    }
})

